import request from '@/utils/request'
/**
 * 获取单车gps信息
 */
function getGPS(id) {
  return request({
    url: `/map/gps/${id}`,
    method: 'get'
  })
}
/**
 * 获取单车信息
 */
function getInfo(id) {
  return request({
    url: `/map/car/info/${id}`,
    method: 'get'
  })
}
/**
 * 获取获取所有车辆GPS信息
 */
function getAllGps() {
  return request({
    url: '/map/all/gps',
    method: 'get'
  })
}
/**
 * 获取统计数量
 */
function getStatisticsCount() {
  return request({
    url: '/home/getStatisticsCount',
    method: 'post'
  })
}
/**
 * 获取前五里程车辆
 */
function getMileageTop() {
    return request({
      url: '/home/getMileageTop',
      method: 'post'
    })
  }
  /**
 * 获取前五故障车辆
 */
function getFaultTop() {
    return request({
      url: '/home/getFaultTop',
      method: 'post'
    })
  }
/**
 * 获取前五驾驶行为平均分车辆
 */
function getAvgScoreTop() {
    return request({
      url: '/home/getAvgScoreTop',
      method: 'post'
    })
  }
  /**
 * 获取前五急加速次数车辆
 */
function getHarshAccelerationTop() {
    return request({
      url: '/home/getHarshAccelerationTop',
      method: 'post'
    })
  }
  /**
 * 获取前五急转弯次数车辆
 */
function getHarshTurnTop() {
    return request({
      url: '/home/getHarshTurnTop',
      method: 'post'
    })
  }
  /**
 * 获取前五急减速次数车辆
 */
function getHarshDecelerationTop() {
    return request({
      url: '/home/getHarshDecelerationTop',
      method: 'post'
    })
  }
/**
 * 获取当前账号设置的最大车速
 */
function getMaxSpeed() {
  return request({
    url:'/user/getMaxSpeed',
    method: 'get'
  })
}
/**
 * 设置最大车速
 */
 function setMaxSpeed(data) {
  return request({
    url:'/user/setMaxSpeed',
    method: 'put',
    data
  })
}
  export{getGPS,setMaxSpeed,getInfo,getAllGps,getStatisticsCount,getMileageTop,getFaultTop,getAvgScoreTop,getHarshAccelerationTop,getHarshTurnTop,getHarshDecelerationTop,getMaxSpeed}
